import React, { createContext, useState, useEffect } from 'react';
import s from './StatsIndicator.module.scss';
import cx from 'classnames';
import VisualStatus from "@/shared/ui/VisualStatus";
import TextBlock from "@/shared/ui/TextBlock";

const { Provider, Consumer } = React.createContext({});

/* -------------------------------------------------------------------------------------------------
 * StatsIndicatorGroup
 * -----------------------------------------------------------------------------------------------*/
type StatsIndicatorGroupProps = {
  selectedItems?: string[], 
  onChange?: (...props: any) => void;
  className?: string, 
  children: React.ReactNode;
}

const StatsIndicatorGroup = (props: StatsIndicatorGroupProps) => {
  const {
    selectedItems = [],
    className = '',
    onChange = () => {},
    children,
  } = props;

  return (
    <Provider value={{ selectedItems, onChange }}>
      <div className={className}>
        {children}
      </div>
    </Provider>
  );
}


/* -------------------------------------------------------------------------------------------------
 * StatsIndicator
 * -----------------------------------------------------------------------------------------------*/
type StatsIndicatorProps = {
  name: string;
  status:  'success' | 'error' | 'warning' | 'info';
  title: string;
  value: string;
  subValue?: string;
  className?: string;
  size?: 'xl' | 'l';
  isLoading?: boolean;
}

const StatsIndicator = (props: StatsIndicatorProps) => {
  const {
    status,
    className = '',
    title,
    value,
    subValue,
    size,
    name,
    isLoading = false,
  } = props;

  return (
    <Consumer>
      {({ selectedItems = [], onChange }: any) => {
        const isActive = selectedItems.includes(name);
        return (
          <button 
            onClick={() => {
              if (typeof onChange === 'function') {
                const newItems = [...selectedItems].filter((item: string) => isActive ? item !== name : true);
                if (!isActive) {
                  newItems.push(name);
                }
                onChange(newItems);
              }
            }}
            className={cx(
              s.root, 
              className,
              {
                [s.active]: isActive,
              }
            )}
            type="button"
          >
            <VisualStatus status={status}/>
            <TextBlock
              isLoading={isLoading}
              title={title}
              value={value}
              subValue={subValue}
              size={size}
            />
          </button>
        )
      }}
    </Consumer>
  );
}

const Group = StatsIndicatorGroup;
const Item = StatsIndicator;

export {
  Item,
  Group,
  StatsIndicatorGroup,
  StatsIndicator,
};

